const Unauthorized = ({}) => {
    return (
        <h1 className="text-center">You are not authorized to view this page</h1>
    )
}

export default Unauthorized